module.exports = __webpack_public_path__ + "img/67.f830e8e.svg";